<div class="grid">
  <div class="col-12">
    <app-total-investments
      [customersTotals]="customersTotals"></app-total-investments>
  </div>
  <div class="col-12" *appHasRole="[ROLE_ADMIN, ROLE_MASTER]">
    <app-dashboard-chart-daily-gains></app-dashboard-chart-daily-gains>
  </div>
</div>
